module.exports = __webpack_public_path__ + "img/4-5.cf1254f6.png";